<msf-list-page-wrapper
  [leftSize]="isSmallScreen ? '12' : '9'"
  [rightSize]="isSmallScreen ? '0' : '3'"
  [rightBackground]="false">
  <div
    left
    #left>
    <div class="content-wrapper">
      <div class="main-content">
        <div class="management-header">
          <div class="management-title">
            <img
              src="assets/icons/main/light/users-main-icon.svg"
              alt="" />
            <h2>{{ "Roles and Permissions" | translate }}</h2>
          </div>
          <div class="add-button-wrapper">
            <button
              pButton
              type="button"
              [label]="'Add' | translate"
              icon="pi pi-plus"
              class="p-button-rounded add-button"
              (click)="toggleAddDropdown()"></button>
            <div
              class="add-dropdown"
              *ngIf="showAddDropdown">
              <div
                class="dropdown-item"
                (click)="onAddIndividual.emit(); showAddDropdown = false">
                {{ "Add Individual" | translate }}
              </div>
              <div
                class="dropdown-item"
                (click)="onAddLegal.emit(); showAddDropdown = false">
                {{ "Add Legal Entity" | translate }}
              </div>
              <div class="dropdown-divider"></div>
              <div
                class="dropdown-item"
                (click)="onImportIndividual.emit(); showAddDropdown = false">
                {{ "Import Individuals" | translate }}
              </div>
              <div
                class="dropdown-item"
                (click)="onImportLegal.emit(); showAddDropdown = false">
                {{ "Import Legal Entities" | translate }}
              </div>
            </div>
          </div>
        </div>

        <div class="table-section">
          <p-table
            #userTable
            [value]="users"
            [paginator]="true"
            [rows]="pageSize"
            [rowsPerPageOptions]="[10, 25, 50, 100]"
            styleClass="p-datatable-sm user-table"
            paginatorStyleClass="custom-paginator">
            <ng-template pTemplate="header">
              <tr>
                <th>{{ "Name" | translate }}</th>
                <th>{{ "Date Created" | translate }}</th>
                <th>{{ "Role" | translate }}</th>
                <th>{{ "Period of Blocking" | translate }}</th>
                <th style="width: 50px"></th>
              </tr>
            </ng-template>

            <ng-template
              pTemplate="body"
              let-user>
              <tr [class.blocked-row]="user.status === 'blocked'">
                <td>
                  <div class="user-info">
                    <span class="username">{{ user.username }}</span>
                    <span class="email">{{ user.email }}</span>
                  </div>
                </td>
                <td>{{ user.createdDate }}</td>
                <td>
                  <span class="role-badge">
                    <span *ngFor="let role of getRoles(user.roles); let i = index; let last = last">
                      {{ role | serverTranslate: "names" }}
                      <span *ngIf="!last">,</span>
                    </span>
                  </span>
                </td>
                <td>{{ user.period }}</td>
                <td>
                  <button
                    pButton
                    type="button"
                    class="p-button-text p-button-sm edit-button"
                    (click)="onEditUser.emit(user)"
                    pTooltip="{{ 'Edit User' | translate }}">
                    <img
                      src="assets/icons/main/light/edit-Button.svg"
                      alt="Edit"
                      style="width: 16px; height: 16px" />
                  </button>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="paginatorleft">
              <div class="paginator-left-content">
                <span class="total-records">{{ "Total" | translate }}: {{ totalRecords }}</span>
                <p-select
                  [options]="pageSizeOptions"
                  [(ngModel)]="pageSize"
                  (onChange)="handlePageSizeChange($event)"
                  styleClass="page-size-dropdown"
                  appendTo="body"
                  [showClear]="false"
                  optionLabel="label"
                  optionValue="value"></p-select>
              </div>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
  <div
    right
    #right
    *ngIf="!isSmallScreen">
    <div class="filters-sidebar">
      <h3>{{ "Filters" | translate }}</h3>
      <div
        class="filter-group"
        style="margin-bottom: 16px">
        <app-generic-selector
          [config]="roleSelectorConfig"
          [label]="'Role' | translate"
          [placeholder]="'Select Role' | translate"
          [(ngModel)]="filters.role"
          (selectionChange)="onFilterChange('role', $event?.normalizedName)"></app-generic-selector>
      </div>
      <div
        class="filter-group"
        style="margin-bottom: 16px">
        <app-generic-selector
          [config]="userSelectorConfig"
          [label]="'NAME_OR_LOGIN' | translate"
          [placeholder]="'Select User' | translate"
          [(ngModel)]="filters.id"
          (selectionChange)="onFilterChange('id', $event?.id)"></app-generic-selector>
      </div>
      <div
        class="filter-group"
        style="margin-bottom: 16px">
        <app-generic-selector
          [config]="orgSelectorConfig"
          [label]="'Organization' | translate"
          [placeholder]="'Select Organization' | translate"
          [(ngModel)]="filters.userBusinessId"
          (selectionChange)="onFilterChange('userBusinessId', $event?.id)"></app-generic-selector>
      </div>
      <div
        class="filter-group"
        style="margin-bottom: 16px">
        <label class="block mb-2 font-medium">{{ "User Type" | translate }}</label>

        <app-localized-dropdown
          [options]="userTypeOptions"
          [(ngModel)]="filters.userBusinessType"
          (onChange)="onFilterChange('userBusinessType', $event.value)"
          [placeholder]="'Select Type' | translate"
          [showClear]="true"
          styleClass="w-full sidebar-select"></app-localized-dropdown>
      </div>
      <div
        class="filter-group"
        style="margin-bottom: 24px">
        <label class="block mb-2 font-medium">{{ "Status" | translate }}</label>

        <app-localized-dropdown
          [options]="statusOptions"
          [(ngModel)]="filters.isBlocked"
          (onChange)="onFilterChange('isBlocked', $event.value)"
          [placeholder]="'Select Status' | translate"
          [showClear]="true"
          styleClass="w-full sidebar-select"></app-localized-dropdown>
      </div>
      <div class="filter-actions">
        <button
          pButton
          [label]="'Apply' | translate"
          (click)="applyFilters()"
          class="action-btn"></button>
        <button
          pButton
          [label]="'Clear' | translate"
          class="p-button-outlined action-btn"
          (click)="clearFilters()"></button>
      </div>
    </div>
  </div>
</msf-list-page-wrapper>
